import {GuessTeam} from "./GuessNeighbourhoods";
import {AvatarGroup, Grid, Tooltip} from "@mui/material";
import {TeamGuessTooltip} from "./TeamGuessTooltip";
import EmployeeAvatar from "../employee-avatar/EmployeeAvatar";
import React from "react";
import {NeighbourhoodMatchScoreChip} from "./NeighbourhoodMatchScoreChip";
import {TeamPathBox} from "./TeamPathBox";

export function TeamGuessPane({team, globalTeamSize, localTeamSize}: {
    team: GuessTeam,
    globalTeamSize: number,
    localTeamSize: number,
}) {
    const teamPath = team.commonManager.teamPath || [];
    return (
        <Grid container spacing={1} flexDirection="row" alignItems="center" sx={{mx: "1.5rem"}}>
            <Grid width="160px">
                <Tooltip
                    title={
                        <TeamGuessTooltip
                            team={team}
                            globalTeamSize={globalTeamSize}
                            localTeamSize={localTeamSize}
                        />
                    }>
                    <AvatarGroup max={4}>
                        {team.withManager && (
                            <EmployeeAvatar employee={team.commonManager}/>
                        )}

                        {team.teammates.map(teammate => (
                            <EmployeeAvatar employee={teammate} key={teammate.id}/>
                        ))}
                    </AvatarGroup>
                </Tooltip>
            </Grid>
            <Grid size="grow">
                <TeamPathBox teamPath={teamPath}/>
            </Grid>
            <Grid flexDirection="row" spacing={1} container >
                <NeighbourhoodMatchScoreChip score={team.weight} type="global" size="small"/>
                <NeighbourhoodMatchScoreChip score={team.localWeight} type="local" size="small"/>
            </Grid>
        </Grid>
    );
}